module.exports = __webpack_public_path__ + "static/media/my-workspace.979b22b2.png";